import React from 'react';
import { Modal } from '@spotify-internal/anchor-ds';
import { ButtonPrimary } from '@spotify-internal/encore-web';
import { css } from 'emotion';

const DeleteMediaConfirmationModal = ({
  hideConfirmationModal,
  onDelete,
  deleteStatus,
}: {
  hideConfirmationModal: () => void;
  onDelete: () => void;
  deleteStatus: string;
}) => (
  <Modal
    isShowing
    onClose={hideConfirmationModal}
    aria-labelledby="delete-media-confirmation-modal-title"
    size="small"
  >
    <Modal.Title id="delete-media-confirmation-modal-title">
      Delete this audio?
    </Modal.Title>
    <Modal.Body>
      This action will remove all media content associated with your episode.
    </Modal.Body>
    {deleteStatus === 'error' && (
      <Modal.Error>Something went wrong. Please try again.</Modal.Error>
    )}
    <Modal.Footer>
      <ButtonPrimary
        colorSet="negative"
        className={css`
          color: #ffffff !important;
        `}
        onClick={hideConfirmationModal}
      >
        Cancel
      </ButtonPrimary>
      <ButtonPrimary disabled={deleteStatus === 'loading'} onClick={onDelete}>
        {deleteStatus === 'loading' ? 'Deleting...' : 'Delete'}
      </ButtonPrimary>
    </Modal.Footer>
  </Modal>
);

export { DeleteMediaConfirmationModal };
